// test1050
(1050 && 0);
